// Elevation-callout glyph — the circle counterpart of ErefStatusIcon's layers and
// FurnitureStatusIcon's diamond, drawn at the same 12x12 box and default grey so the three read as
// one family in the header's + Add menu.
export const EcallIcon = () => {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="6" cy="6" r="5" stroke="var(--clr-midGray)" />
		</svg>
	)
}
